import { render, staticRenderFns } from "./OccupancyRatio.vue?vue&type=template&id=2b00e72a&scoped=true&"
import script from "./OccupancyRatio.vue?vue&type=script&lang=js&"
export * from "./OccupancyRatio.vue?vue&type=script&lang=js&"
import style0 from "./OccupancyRatio.vue?vue&type=style&index=0&id=2b00e72a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00e72a",
  null
  
)

export default component.exports